export default __webpack_public_path__ + "static/media/bottom-area.0fb62c4a.png";